/**
 * Show more
 */

const show_more = (args) => {
    // setup args
    let wrapper = args.wrapper;
    let button = wrapper.querySelector('.js-show-more-button');
    let content = wrapper.querySelector('.js-show-more-content');

    // validate
    if (!button || !content) {
        // console.log('Invalid show more args');
        return;
    }

    function buttonPressed() {
        const open = button.getAttribute('aria-expanded') === 'true';

        if (open) {
            button.setAttribute('aria-expanded', 'false');
            content.style.display = 'none';
            button.innerHTML = button.getAttribute('data-label-more');
        } else {
            button.setAttribute('aria-expanded', 'true');
            content.style.display = 'block';
            button.innerHTML = button.getAttribute('data-label-less');
        }
    }

    function init() {
        button.addEventListener('click', () => {
            buttonPressed();
        });
    }

    init();

    // make the call chainable
    return this;
};

/**
 * Init "Show more" -elements
 */
const show_more_elements = document.querySelectorAll('.js-show-more');
for (let i = 0; i < show_more_elements.length; i++) {
    show_more({
        wrapper: show_more_elements[i],
    });
}
